module.exports = __webpack_public_path__ + "GP.png?b0fe617476402b8656144d41e3cac6ad";